module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bioInfoList.length > 2) ? _c('section', _vm._l((_vm.bioInfoList), function(bio, index) {
    return _c('div', {
      key: index
    }, [_c('p', {
      staticClass: "h1 info-title"
    }, [_vm._v(_vm._s(bio.title))]), _vm._v(" "), _c('dl', {
      staticClass: "row"
    }, _vm._l((bio.infoList), function(info, i) {
      return _c('div', {
        key: i,
        staticClass: "info-list"
      }, [_c('dt', {
        staticClass: "col-sm-3"
      }, [_vm._v(_vm._s(info.property))]), _vm._v(" "), _c('dd', {
        staticClass: "col-sm-9"
      }, [_vm._v(_vm._s(info.value))])])
    }), 0)])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040052ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/BioInfo.vue
// module id = 247
// module chunks = 0